<div class="pizza-card">
  <div class="card-header">
    <h3 class="section-title">
      <i class="pi pi-chart-pie"></i>
      {{ texts.dados_de_movimentacoes }}
    </h3>
  </div>

  <!-- Filtros -->
  <div class="filtros-row">
    <div class="filtros-esquerda">
      <p-dropdown [options]="moedas" optionLabel="label" optionValue="value"
                  [(ngModel)]="moedaPizza" (onChange)="onFiltroChange()"
                  styleClass="moeda-dropdown"></p-dropdown>
      <p-dropdown [options]="meses" optionLabel="label" optionValue="value"
                  [(ngModel)]="mesPizza" (onChange)="onFiltroChange()"
                  styleClass="mes-dropdown"></p-dropdown>
      <p-dropdown [options]="anos" optionLabel="label" optionValue="value"
                  [(ngModel)]="anoPizza" (onChange)="onFiltroChange()"
                  styleClass="ano-dropdown"></p-dropdown>
    </div>
    <button pButton type="button"
            [icon]="modoGrafico ? 'pi pi-list' : 'pi pi-chart-pie'"
            class="p-button-rounded p-button-text"
            (click)="toggleModo()">
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
  </div>

  <div *ngIf="!loading">
    <!-- Graficos de pizza lado a lado no desktop -->
    <div class="pizzas-grid">
      <!-- Despesas -->
      <div class="pizza-section">
        <h4 class="pizza-titulo">{{ texts.despesas }}</h4>

        <div class="pizza-container" *ngIf="modoGrafico">
          <p-chart type="pie" [data]="pieDespesaData" [options]="pieDespesaOptions" [plugins]="[piePercentPlugin]"></p-chart>
        </div>

        <div class="legenda-lista">
          <!-- Itens clicaveis com drill-down (replica grafico_pizza_widget.dart onTap) -->
          <div class="legenda-item clicavel"
               *ngFor="let item of dadosDespesas; let i = index; trackBy: trackByTipoEnum"
               (click)="onItemDespesaClick(item)"
               [title]="item.nome">
            <span class="legenda-cor" [style.background]="item.cor || getCorItem(i)"></span>
            <span class="legenda-nome">{{ item.nome }}</span>
            <span class="legenda-valor">
              {{ item.valor | currency:pizzaCurrencySymbol:'symbol-narrow':pizzaCurrencyDigits:pizzaCurrencyLocale }}
            </span>
          </div>
          <div class="legenda-item total" *ngIf="dadosDespesas.length > 0">
            <span class="legenda-cor" style="background: transparent"></span>
            <span class="legenda-nome font-bold">{{ texts.total }}</span>
            <span class="legenda-valor font-bold">
              {{ totalDespesas | currency:pizzaCurrencySymbol:'symbol-narrow':pizzaCurrencyDigits:pizzaCurrencyLocale }}
            </span>
          </div>
        </div>
      </div>

      <p-divider layout="vertical" class="divider-desktop"></p-divider>
      <p-divider class="divider-mobile"></p-divider>

      <!-- Receitas -->
      <div class="pizza-section">
        <h4 class="pizza-titulo">{{ texts.receitas }}</h4>

        <div class="pizza-container" *ngIf="modoGrafico">
          <p-chart type="pie" [data]="pieReceitaData" [options]="pieReceitaOptions" [plugins]="[piePercentPlugin]"></p-chart>
        </div>

        <div class="legenda-lista">
          <!-- Itens clicaveis com drill-down (replica grafico_pizza_widget.dart onTap) -->
          <div class="legenda-item clicavel"
               *ngFor="let item of dadosReceitas; let i = index; trackBy: trackByTipoEnum"
               (click)="onItemReceitaClick(item)"
               [title]="item.nome">
            <span class="legenda-cor" [style.background]="item.cor || getCorItem(i)"></span>
            <span class="legenda-nome">{{ item.nome }}</span>
            <span class="legenda-valor">
              {{ item.valor | currency:pizzaCurrencySymbol:'symbol-narrow':pizzaCurrencyDigits:pizzaCurrencyLocale }}
            </span>
          </div>
          <div class="legenda-item total" *ngIf="dadosReceitas.length > 0">
            <span class="legenda-cor" style="background: transparent"></span>
            <span class="legenda-nome font-bold">{{ texts.total }}</span>
            <span class="legenda-valor font-bold">
              {{ totalReceitas | currency:pizzaCurrencySymbol:'symbol-narrow':pizzaCurrencyDigits:pizzaCurrencyLocale }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
